import { i18nRouting } from '@/src/shared/config';

type SupportedLocale = (typeof i18nRouting.locales)[number];

export function resolveLocaleFromPathname(pathname: string): SupportedLocale {
  const [first] = pathname.split('/').filter(Boolean);

  if (first && i18nRouting.locales.includes(first as SupportedLocale)) {
    return first as SupportedLocale;
  }

  return i18nRouting.defaultLocale;
}
